import script from "./form1.vue?vue&type=script&setup=true&lang=js"
export * from "./form1.vue?vue&type=script&setup=true&lang=js"

import "./form1.vue?vue&type=style&index=0&id=4d1f42a5&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1f42a5"]])

export default __exports__